module.exports = __webpack_public_path__ + "img/xmbx.0c11e353.png";